import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/* Componente de formulario */
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

/* Importación de constantes */
import * as constants from '../../constants/general';

/* Provider responsable de codigo generico */
import { UtilsService } from '../../utils.service';
import { PointEarnedUser } from 'src/app/badges/badges-utils';
import { advertisement, ServiceService } from 'src/app/service.service';

@Component({
  selector: 'app-angulos',
  templateUrl: './angulos.page.html',
  styleUrls: ['./angulos.page.scss', '../../../assets/scss/styles.scss'],
})
export class AngulosPage implements OnInit {
  previousSideA: number = null;
  previousSideB: number = null;
  previousSideC: number = null;
  previousAngle: number = null;
  /* Variables encargadas del almacenamiento del formulario */
  public anglesForm: FormGroup = null;
  public sideA: AbstractControl;
  public sideB: AbstractControl;
  public sideC: AbstractControl;
  public angle: AbstractControl;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();
  private degrees = constants.DEGREES;
  private radians = constants.RADIANS;

  /* Flags */
  private activeCalculation: boolean;
  
  constructor( private router: Router, 
              public services: ServiceService,
               private _form_Builder: FormBuilder,
               public _utilities_provider: UtilsService, ) {

    this.anglesForm = this._form_Builder.group({
      sideA: ['', Validators.compose([ Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ]) ],
      sideB: ['', Validators.compose([ Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ]) ],
      sideC: ['', Validators.compose([ Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ]) ],
      angle: ['', Validators.compose([ Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ]) ],
    });

    this.sideA = this.anglesForm.controls.sideA;
    this.sideB = this.anglesForm.controls.sideB;
    this.sideC = this.anglesForm.controls.sideC;
    this.angle = this.anglesForm.controls.angle;
  }

  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  isSharing:boolean = false;
  public calcular() {

    if ( this.sideA.valid ) {

      const sideATmp = parseFloat(this.sideA.value)
      const sideAATmp = sideATmp * sideATmp;

      if ( this.sideB.valid ) {
        // Side a and b
        const sideBTmp = parseFloat(this.sideB.value)
        const sideBBTmp = sideBTmp * sideBTmp;
        const resultCTmp = Math.sqrt(sideAATmp + sideBBTmp);
        
        const divisionTmp = sideATmp/sideBTmp;
        const resultAngleTmp = Math.atan( divisionTmp ) * this.degrees;

        this.sideC.setValue(this._utilities_provider.truncNumber(resultCTmp, 4));
        this.angle.setValue(this._utilities_provider.truncNumber(resultAngleTmp, 4));

      } else if ( this.sideC.valid ) {
        // Side a and c
        const sideCTmp = parseFloat(this.sideC.value);
        const sideCCTmp = sideCTmp * sideCTmp;
        const resultBTmp = Math.sqrt(sideCCTmp - sideAATmp);

        const divisionTmp = sideATmp / sideCTmp;
        const resultAngleTmp = Math.asin( divisionTmp ) * this.degrees;

        this.sideB.setValue( this._utilities_provider.truncNumber(resultBTmp, 4) );
        this.angle.setValue( this._utilities_provider.truncNumber(resultAngleTmp, 4) );

      } else if ( this.angle.valid ) {
        // Side a and angle
        const angleValueTmp = parseFloat(this.angle.value);
        const calcTanTmp = Math.tan( angleValueTmp * this.radians );
        const resultBTmp = sideATmp / calcTanTmp;

        const calcSinTmp = Math.sin( angleValueTmp * this.radians );
        const resultCTmp = sideATmp / calcSinTmp;

        this.sideB.setValue(this._utilities_provider.truncNumber(resultBTmp, 4));
        this.sideC.setValue(this._utilities_provider.truncNumber(resultCTmp, 4));
        
      }

    } else if ( this.sideA.invalid ) {

      if ( this.sideB.valid ) {
        const sideBTmp = parseFloat(this.sideB.value)
        const sideBBTmp = sideBTmp * sideBTmp;

        if ( this.sideC.valid ) {
          // Side b and c
          const sideCTmp = parseFloat(this.sideC.value);
          const sideCCTmp = sideCTmp * sideCTmp;
          const resultATmp = Math.sqrt(sideCCTmp - sideBBTmp);
        
          const divisionTmp = sideBTmp / sideCTmp;
          const resultAngleTmp = Math.acos( divisionTmp) * this.degrees;

          this.sideA.setValue(this._utilities_provider.truncNumber(resultATmp, 4));
          this.angle.setValue(this._utilities_provider.truncNumber(resultAngleTmp, 4));

        } else if ( this.angle.valid ) {
          // Side b and angle
          const angleValueTmp = parseFloat(this.angle.value);
          const calcTanTmp = Math.tan( angleValueTmp * this.radians);
          const resultATmp = sideBTmp * calcTanTmp;
        
          const calcCosTmp = Math.cos( angleValueTmp * this.radians );
          const resultCTmp = sideBTmp / calcCosTmp;

          this.sideA.setValue(this._utilities_provider.truncNumber(resultATmp, 4));
          this.sideC.setValue(this._utilities_provider.truncNumber(resultCTmp, 4));

        }

      } else if ( this.sideB.invalid ) {
        // Side c and angle
        const angleValueTmp = parseFloat(this.angle.value);
        const sideCTmp = parseFloat(this.sideC.value);

        const calcSinTmp = Math.sin( angleValueTmp * this.radians );
        const resultATmp = sideCTmp * calcSinTmp;
      
        const calcSinBTmp = Math.cos( angleValueTmp * this.radians );
        const resultBTmp = sideCTmp * calcSinBTmp;

        this.sideA.setValue(this._utilities_provider.truncNumber(resultATmp, 4));
        this.sideB.setValue(this._utilities_provider.truncNumber(resultBTmp, 4));

      }

    }

    
    if((this.sideA.value != this.previousSideA || this.sideB.value != this.previousSideB || this.sideC.value != this.previousSideC || this.angle.value != this.previousAngle) && !this.isSharing){
      this.previousSideA = this.sideA.value;
      this.previousSideB = this.sideB.value;
      this.previousSideC = this.sideC.value;
      this.previousAngle = this.angle.value;
      this.isSharing = true;
      setTimeout(()=>{ this.isSharing = false; },20000);
      this.services.addPointCalculator();
    }
  }

  public resert() {
    this.anglesForm.reset();
  }

  home() {
    return this.router.navigate(['/calculadora']);
  }

  routesTab(option: number) {
    switch (option){
      case 1: this.router.navigate(['/revo']); break;
      case 2: this.router.navigate(['/velocity']); break;
      case 3: this.router.navigate(['/avan']); break;
      case 4: this.router.navigate(['/marche']); break;
      case 5: this.router.navigate(['/torneado']); break;
    }
  }

}
